module.exports = __webpack_public_path__ + "static/media/about-catalog-back.3ccb019f.svg";